import React from 'react'
import { useState } from 'react'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeServiceLifeForm from './ChangeServiceLifeForm'

const ChangeServiceLifeButton = ({ writeOffActItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={writeOffActItem.serviceLife}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування строку служби'}
            disableClickOutside={true}
            content={
                <ChangeServiceLifeForm
                    writeOffActItemBd={writeOffActItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeServiceLifeButton